import { useEffect, useLayoutEffect, useRef, useState } from 'react'

interface BillingToggleProps {
  monthlyLabel: string
  yearlyLabel: string
  savingsLabel: string
  value: 'monthly' | 'annually'
  onChange: (value: 'monthly' | 'annually') => void
}

export default function BillingToggle(props: BillingToggleProps) {
  const { monthlyLabel, yearlyLabel, savingsLabel, value, onChange } = props

  const monthlyRef = useRef<HTMLButtonElement>(null)
  const yearlyRef = useRef<HTMLButtonElement>(null)
  const [pillStyle, setPillStyle] = useState<{ left: number; width: number }>({
    left: 0,
    width: 0
  })

  const updatePillPosition = () => {
    const activeButton =
      value === 'monthly' ? monthlyRef.current : yearlyRef.current
    if (activeButton) {
      setPillStyle({
        left: activeButton.offsetLeft,
        width: activeButton.offsetWidth
      })
    }
  }

  // measure synchronously so the pill never flashes at its previous position
  useLayoutEffect(() => {
    updatePillPosition()
  }, [value, monthlyLabel, yearlyLabel, savingsLabel])

  useEffect(() => {
    window.addEventListener('resize', updatePillPosition)
    return () => window.removeEventListener('resize', updatePillPosition)
  }, [])

  return (
    <div className="billing-toggle">
      <span
        className="billing-toggle__pill"
        style={{ left: pillStyle.left, width: pillStyle.width }}
      />
      <button
        ref={monthlyRef}
        id="monthly-link"
        type="button"
        className={`billing-toggle__button ${
          value === 'monthly' ? 'billing-toggle__button--active' : ''
        }`}
        aria-pressed={value === 'monthly'}
        onClick={() => onChange('monthly')}
      >
        {monthlyLabel}
      </button>
      <button
        ref={yearlyRef}
        id="yearly-link"
        type="button"
        className={`billing-toggle__button billing-toggle__button--yearly ${
          value === 'annually' ? 'billing-toggle__button--active' : ''
        }`}
        aria-pressed={value === 'annually'}
        onClick={() => onChange('annually')}
      >
        <span>{yearlyLabel}</span>
        <span className="billing-toggle__savings">{savingsLabel}</span>
      </button>
    </div>
  )
}
